export default __webpack_public_path__ + "static/media/settings-icon.63cf5ddc.svg";